import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, isRef as _isRef, vModelRadio as _vModelRadio, withDirectives as _withDirectives, vModelText as _vModelText, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { class: "error-warning-update" }
const _hoisted_2 = {
  id: "detailList",
  class: ""
}
const _hoisted_3 = { class: "d-inline-block" }
const _hoisted_4 = { class: "form-check" }
const _hoisted_5 = ["name", "id", "value"]
const _hoisted_6 = ["for"]
const _hoisted_7 = { key: 0 }
const _hoisted_8 = { key: 1 }
const _hoisted_9 = { class: "hstack gap-2" }

import {computed, ref, watch, onMounted} from "vue";
import {useGlobalMessagesStore} from "@/stores/globalMessagesStore";
import axios from "axios";
import {handleError} from "@/stores/storeHelper";

export default /*@__PURE__*/_defineComponent({
  __name: 'ErrorsAndWarningsUpdate',
  props: {
    item: {},
    url: {},
    dataset: {},
    uploadHeaders: { default: {} }
  },
  emits: ["dismiss"],
  setup(__props: any, { emit: __emit }) {

const globalMessages = useGlobalMessagesStore();
//props and variables
const props = __props;

const emit = __emit;

const statusList = [
    {id: "unresolved", text: "Unresolved", value: "0"},
    {id: "dismissed", text: "Dismissed/Cleared", value: "1"},
];
var statusValue = ref("");
var explanationValue = ref("");
var dataItem = ref({} as any);

//computed properties
const incidentNumberLabel = computed(() => {
    if (props.dataset?.toLocaleLowerCase() == "communityPolicing") {
        return "Stop Number";
    }

    return "Incident Number";
});
const typeAndCode = computed(() => {
    return `${dataItem.value["errorType"]} ${dataItem.value["errorCode"]}`;
});
const errorDesc = computed(() => {
    return dataItem.value["description"];
});
const idValue = computed(() => {
    return props.dataset == "communityPolicing" ? dataItem.value["stopNumber"] : dataItem.value["incidentNumber"];
});

//methods section
async function handleConfirmClick() {
    if (
        statusValue.value != null &&
        explanationValue.value != null &&
        statusValue.value.length > 0 &&
        explanationValue.value.length > 0
    ) {
        let dataToPost = {
            id: dataItem.value.id,
            status: statusValue.value,
            explanation: explanationValue.value,
            code: dataItem.value["errorCode"],
        };

        try {
            await axios.post(props.url, dataToPost, {
                headers: props.uploadHeaders,
            });
            globalMessages.push({message: "Error or warning updated successfully.", type: "success"});
        } catch (error) {
            handleError(error);
            throw error;
        } finally {
            handleDismissClick();
        }
    }
}
function handleDismissClick() {
    emit("dismiss");
}

function getData() {
    if (props.item != null) {
        dataItem.value = props.item;
    }
}

function getRequiredCssClass(baseCssClasses, isValid) {
    if (isValid) {
        return baseCssClasses;
    }

    return baseCssClasses + " is-invalid";
}

watch(
    () => props.item,
    (item, prevItem) => {
        if (item != null) {
            dataItem.value = item;

            if (dataItem.value["isAcknowledged"]) {
                statusValue.value = "1";
            } else {
                statusValue.value = "0";
            }

            explanationValue.value = dataItem.value["explanation"];
        }
    }
);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("dl", _hoisted_2, [
      _cache[4] || (_cache[4] = _createElementVNode("dt", null, "Agency Name:", -1)),
      _createElementVNode("dd", null, _toDisplayString(_unref(dataItem).agency), 1),
      _cache[5] || (_cache[5] = _createElementVNode("dt", null, "Agency Ori:", -1)),
      _createElementVNode("dd", null, _toDisplayString(_unref(dataItem).ori), 1),
      _createElementVNode("dt", null, _toDisplayString(incidentNumberLabel.value) + ":", 1),
      _createElementVNode("dd", null, _toDisplayString(idValue.value), 1),
      _cache[6] || (_cache[6] = _createElementVNode("dt", null, "Error/Warning description:", -1)),
      _createElementVNode("dd", null, [
        _createElementVNode("span", null, _toDisplayString(typeAndCode.value), 1),
        _createTextVNode(" - " + _toDisplayString(errorDesc.value), 1)
      ]),
      _cache[7] || (_cache[7] = _createElementVNode("dt", null, "Status:", -1)),
      _createElementVNode("dd", null, [
        _createElementVNode("div", _hoisted_3, [
          (_openBlock(), _createElementBlock(_Fragment, null, _renderList(statusList, (status) => {
            return _createElementVNode("div", _hoisted_4, [
              _withDirectives(_createElementVNode("input", {
                class: "form-check-input",
                type: "radio",
                name: status.id,
                id: status.id,
                value: status.value,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_isRef(statusValue) ? (statusValue).value = $event : statusValue = $event)),
                required: ""
              }, null, 8, _hoisted_5), [
                [_vModelRadio, _unref(statusValue)]
              ]),
              _createElementVNode("label", {
                class: "form-check-label",
                for: status.id
              }, _toDisplayString(status.text), 9, _hoisted_6)
            ])
          }), 64))
        ])
      ])
    ]),
    (_unref(statusValue) == '1')
      ? (_openBlock(), _createElementBlock("dl", _hoisted_7, [
          _cache[8] || (_cache[8] = _createElementVNode("dt", null, "Explanation/Justification:", -1)),
          _createElementVNode("dd", null, [
            _withDirectives(_createElementVNode("textarea", {
              class: _normalizeClass(
                        getRequiredCssClass('form-control', _unref(explanationValue) != null && _unref(explanationValue).length > 0)
                    ),
              rows: "5",
              style: {"width":"80%"},
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_isRef(explanationValue) ? (explanationValue).value = $event : explanationValue = $event)),
              required: ""
            }, null, 2), [
              [_vModelText, _unref(explanationValue)]
            ])
          ])
        ]))
      : _createCommentVNode("", true),
    (_unref(dataItem)['isAcknowledged'] && _unref(statusValue) == '1')
      ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
          _createElementVNode("dl", null, [
            _cache[9] || (_cache[9] = _createElementVNode("dt", null, [
              _createTextVNode(" Action date: "),
              _createElementVNode("label", { id: "ActiondateValue" })
            ], -1)),
            _createElementVNode("dd", null, _toDisplayString(_unref(dataItem)["acknowledgedOn"]), 1),
            _cache[10] || (_cache[10] = _createElementVNode("dt", null, "Actioned by:", -1)),
            _createElementVNode("dd", null, _toDisplayString(_unref(dataItem)["acknowledgedBy"]), 1)
          ])
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_9, [
      _createElementVNode("button", {
        class: "btn btn-primary",
        onClick: _cache[2] || (_cache[2] = _withModifiers(($event: any) => (handleConfirmClick()), ["prevent"]))
      }, " Update "),
      _createElementVNode("button", {
        class: "btn btn-danger",
        onClick: _cache[3] || (_cache[3] = _withModifiers(($event: any) => (handleDismissClick()), ["prevent"]))
      }, " Cancel ")
    ])
  ]))
}
}

})